import "react-datepicker/dist/react-datepicker.css";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DateRangeSelector } from "./DateRangeSelector";
import { Images } from "@/constants/images";
import React from "react";
import { THEME } from "@/constants";
import { SEARCH_PLACEHODER } from "@/constants/strings";

interface ToolBoxProps {
  handleFilterData: (filterType?: string) => void;
  searchInputValue: string;
  setSearchInputValue: (value: string) => void;
  setShowUIFilterModal?: any;
  isFilterApplied: boolean;
}

export const FilterToolBox: React.FC<ToolBoxProps> = ({
  handleFilterData,
  searchInputValue,
  setSearchInputValue,
  setShowUIFilterModal,
  isFilterApplied
}) => {
  return (
    <div className="w-full d-flex flex-row justify-end items-start my-5 gap-3">
      <div className="flex items-center mb-3 px-2 py-1 space-x-1 border border-gray-300 rounded-md" style={{ height: "40px" }}>
        <DateRangeSelector handleFilterData={handleFilterData} />
      </div>

      <div className="flex">
        <Input
          placeholder={SEARCH_PLACEHODER}
          prefix={<SearchOutlined />}
          style={{ height: "40px" }}
          value={searchInputValue}
          onChange={e => setSearchInputValue(e.target.value)}
          onPressEnter={() => {
            if (searchInputValue !== "") {
              handleFilterData("filter");
            } else {
              handleFilterData("clearFilter");
            }
          }}
        />
        <div className="flex items-center ml-3 py-1 space-x-2 border border-gray-300 rounded-md" style={{ height: "40px" }}>
          <Button
            icon={
              <div className="relative w-5 h-5">
                <img src={Images.IconFilter} alt="filter" className="w-full h-full" />
                {isFilterApplied && <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full ring-2 ring-white"></span>}
              </div>
            }
            className="rounded-md border border-gray-300 cursor-pointer"
            style={{
              height: "40px",
              width: "40px",
              color: THEME.COLORS.PRIMARY
            }}
            onClick={() => setShowUIFilterModal(true)}
          ></Button>
        </div>
      </div>
    </div>
  );
};
